<template>
  <div>
    <div :class="collapsible ? 'email-head__row' : ''">
      <div :class="collapsible ? 'email-head__fields' : ''">
        <!--    d99d-->
        <div v-if="showFrom && fromEnabled" class="input-group-wrap">
          <div
            class="input-group small"
            :class="{ error: $v.fromEmailVal.$error }"
          >
            <label class="input-group-label">
              {{
                collapsible
                  ? $t('CONVERSATION.REPLYBOX.EMAIL_HEAD.TO')
                  : $t('CONVERSATION.REPLYBOX.EMAIL_HEAD.FROM.LABEL')
              }}
            </label>
            <div class="input-group-field">
              <contact-input-search-v2
                v-if="collapsible"
                email-mode
                multiple
                skip-selected
                :email="$v.fromEmailVal.$model"
                field="email"
                :placeholder="$t('CONVERSATION.REPLYBOX.EMAIL_HEAD.FROM.ENTER')"
                :non-removable="lockedEmail"
                @on-select-contact="onSelect('fromEmailVal', $event)"
                @input="$v.fromEmailVal.$model = $event"
                @remove-tag="removeTag('fromEmailVal', $event)"
                @blur="onBlur"
              />
              <contact-input-search
                v-else
                skip-selected
                :email="$v.fromEmailVal.$model"
                field="email"
                :placeholder="
                  $t('CONVERSATION.REPLYBOX.EMAIL_HEAD.FROM.PLACEHOLDER')
                "
                @on-select-contact="onSelect('fromEmailVal', $event)"
                @input="$v.fromEmailVal.$model = $event"
                @blur="onBlur"
              />
            </div>
          </div>
          <span v-if="$v.fromEmailVal.$error" class="message">
            {{ $t('CONVERSATION.REPLYBOX.EMAIL_HEAD.FROM.ERROR') }}
          </span>
        </div>
        <!--   . -->
        <div v-if="toEmails && !showFwd">
          <div
            class="input-group small"
            :class="{ error: $v.toEmailsVal.$error }"
          >
            <label class="input-group-label">
              {{ $t('CONVERSATION.REPLYBOX.EMAIL_HEAD.TO') }}
            </label>
            <div class="input-group-field">
              <woot-input
                v-model.trim="$v.toEmailsVal.$model"
                type="text"
                :class="{ error: $v.toEmailsVal.$error }"
                :placeholder="
                  $t('CONVERSATION.REPLYBOX.EMAIL_HEAD.CC.PLACEHOLDER')
                "
                @blur="onBlur"
              />
            </div>
          </div>
        </div>
        <!--    d99d-->
        <div v-if="showFwd && fwdEnabled" class="input-group-wrap">
          <div
            class="input-group small"
            :class="{ error: $v.fwdEmailsVal.$error }"
          >
            <label class="input-group-label">
              {{ $t('CONVERSATION.REPLYBOX.EMAIL_HEAD.FWD.LABEL') }}
            </label>
            <div class="input-group-field">
              <contact-input-search
                multiple
                skip-selected
                :email="$v.fwdEmailsVal.$model"
                field="email"
                :placeholder="
                  $t('CONVERSATION.REPLYBOX.EMAIL_HEAD.FWD.PLACEHOLDER')
                "
                @on-select-contact="onSelect('fwdEmailsVal', $event)"
                @input="$v.fwdEmailsVal.$model = $event"
                @blur="onBlur"
              />
            </div>
          </div>
          <span v-if="$v.fwdEmailsVal.$error" class="message">
            {{ $t('CONVERSATION.REPLYBOX.EMAIL_HEAD.FWD.ERROR') }}
          </span>
        </div>
        <!-- CC -->
        <div v-if="showCc" class="input-group-wrap">
          <div
            class="input-group small"
            :class="{ error: $v.ccEmailsVal.$error }"
          >
            <label class="input-group-label">
              {{ $t('CONVERSATION.REPLYBOX.EMAIL_HEAD.CC.LABEL') }}
            </label>
            <div class="input-group-field">
              <contact-input-search
                multiple
                skip-selected
                :email="$v.ccEmailsVal.$model"
                field="email"
                :placeholder="
                  $t('CONVERSATION.REPLYBOX.EMAIL_HEAD.CC.PLACEHOLDER')
                "
                @on-select-contact="onSelect('ccEmailsVal', $event)"
                @input="$v.ccEmailsVal.$model = $event"
                @blur="onBlur"
              />
            </div>
            <button
              v-if="collapsible"
              type="button"
              class="email-head__remove material-symbols-outlined"
              :aria-label="$t('CONVERSATION.REPLYBOX.EMAIL_HEAD.CC.LABEL')"
              @click.prevent="hideCc"
            >
              close
            </button>
            <woot-button
              v-if="!showBcc && !collapsible"
              variant="clear"
              @click="handleAddBcc"
            >
              {{ $t('CONVERSATION.REPLYBOX.EMAIL_HEAD.ADD_BCC') }}
            </woot-button>
            <woot-button
              v-if="!showFwd && fwdEnabled"
              variant="clear"
              size="small"
              @click="handleSetFwd"
            >
              {{ $t('CONVERSATION.REPLYBOX.EMAIL_HEAD.SET_FWD') }}
            </woot-button>
            <woot-button
              v-if="!showFrom && fromEnabled"
              variant="clear"
              size="small"
              @click="handleSetFrom"
            >
              {{ $t('CONVERSATION.REPLYBOX.EMAIL_HEAD.SET_FROM') }}
            </woot-button>
          </div>
          <span v-if="$v.ccEmailsVal.$error" class="message">
            {{ $t('CONVERSATION.REPLYBOX.EMAIL_HEAD.CC.ERROR') }}
          </span>
        </div>
        <!-- BCC -->
        <div v-if="showBcc" class="input-group-wrap">
          <div
            class="input-group small"
            :class="{ error: $v.bccEmailsVal.$error }"
          >
            <label class="input-group-label">
              {{ $t('CONVERSATION.REPLYBOX.EMAIL_HEAD.BCC.LABEL') }}
            </label>
            <div class="input-group-field">
              <contact-input-search
                multiple
                :email="$v.bccEmailsVal.$model"
                field="email"
                :placeholder="
                  $t('CONVERSATION.REPLYBOX.EMAIL_HEAD.BCC.PLACEHOLDER')
                "
                skip-selected
                @on-select-contact="onSelect('bccEmailsVal', $event)"
                @input="$v.bccEmailsVal.$model = $event"
                @blur="onBlur"
              />
            </div>
            <button
              v-if="collapsible"
              type="button"
              class="email-head__remove material-symbols-outlined"
              :aria-label="$t('CONVERSATION.REPLYBOX.EMAIL_HEAD.BCC.LABEL')"
              @click.prevent="hideBcc"
            >
              close
            </button>
          </div>
          <span v-if="$v.bccEmailsVal.$error" class="message">
            {{ $t('CONVERSATION.REPLYBOX.EMAIL_HEAD.BCC.ERROR') }}
          </span>
        </div>
      </div>
      <div
        v-if="collapsible && (!showCc || !showBcc)"
        class="email-head__toggles"
      >
        <button
          v-if="!showCc"
          type="button"
          class="email-head__toggle"
          @click.prevent="showCc = true"
        >
          + {{ $t('CONVERSATION.REPLYBOX.EMAIL_HEAD.CC.LABEL') }}
        </button>
        <button
          v-if="!showBcc"
          type="button"
          class="email-head__toggle"
          @click.prevent="showBcc = true"
        >
          + {{ $t('CONVERSATION.REPLYBOX.EMAIL_HEAD.BCC.LABEL') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { validEmailsByComma } from './helpers/emailHeadHelper';
import ContactInputSearch from 'dashboard/modules/contact/components/ContactInputSearch.vue';
import ContactInputSearchV2 from 'dashboard/modules/contact/components/ContactInputSearchV2.vue';
export default {
  components: {
    ContactInputSearch,
    ContactInputSearchV2,
  },
  props: {
    ccEmails: {
      type: String,
      default: '',
    },
    bccEmails: {
      type: String,
      default: '',
    },
    // d99d
    fwdEmails: {
      type: String,
      default: '',
    },
    fwdEnabled: {
      type: Boolean,
      default: false,
    },
    fwdOpened: {
      type: Boolean,
      default: false,
    },
    fromEnabled: {
      type: Boolean,
      default: false,
    },
    fromEmail: {
      type: String,
      default: '',
    },
    // .
    toEmails: {
      type: String,
      default: '',
    },
    collapsible: {
      type: Boolean,
      default: false,
    },
    lockedEmail: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showCc: !this.collapsible,
      showBcc: false,
      showFwd: this.fwdOpened, // d99d
      showFrom: this.collapsible, // d99d
      ccEmailsVal: '',
      bccEmailsVal: '',
      fwdEmailsVal: '', // d99d
      fromEmailVal: '', // d99d
      toEmailsVal: '',
    };
  },
  watch: {
    bccEmails(newVal) {
      if (newVal !== this.bccEmailsVal) {
        this.bccEmailsVal = newVal;
      }
    },
    // d99d
    fwdEmails(newVal) {
      if (newVal !== this.fwdEmailsVal) {
        this.fwdEmailsVal = newVal;
      }
    },
    fromEmail(newVal) {
      if (newVal !== this.fromEmailVal) {
        this.fromEmailVal = newVal;
        if (newVal) this.showFrom = true;
      }
    },
    // .
    ccEmails(newVal) {
      if (newVal !== this.ccEmailsVal) {
        this.ccEmailsVal = newVal;
        if (newVal) this.showCc = true;
      }
    },
    toEmails(newVal) {
      if (newVal !== this.toEmailsVal) {
        this.toEmailsVal = newVal;
      }
    },
  },
  mounted() {
    this.ccEmailsVal = this.ccEmails;
    this.bccEmailsVal = this.bccEmails;
    if (this.ccEmails) this.showCc = true;
    if (this.bccEmails) this.showBcc = true;
    this.fwdEmailsVal = this.fwdEmails; // d99d
    this.fromEmailVal = this.fromEmail; // d99d
    this.toEmailsVal = this.toEmails;
    if (this.fromEmail) this.showFrom = true; // d99d
  },
  validations: {
    ccEmailsVal: {
      hasValidEmails(value) {
        return validEmailsByComma(value);
      },
    },
    bccEmailsVal: {
      hasValidEmails(value) {
        return validEmailsByComma(value);
      },
    },
    // d99d
    fwdEmailsVal: {
      hasValidEmails(value) {
        return validEmailsByComma(value);
      },
    },
    fromEmailVal: {
      hasValidEmails(value) {
        return validEmailsByComma(value);
      },
    },
    // .
    toEmailsVal: {
      hasValidEmails(value) {
        return validEmailsByComma(value);
      },
    },
  },
  methods: {
    onSelect(field, { email }) {
      const oldVal = this.$v[field].$model.replaceAll(',', ' ').split(' ');
      if (!validEmailsByComma(oldVal.slice(-1)[0])) oldVal.pop();
      let newVal = [oldVal.filter(val => val), email.replaceAll(',', ' ')]
        .flat()
        .filter(val => val)
        .concat([' ']) // add comma after last selected contact
        .join(', ');
      if (field === 'fromEmailVal' && !this.collapsible) {
        newVal = newVal.replace(/, *$/, '');
      }
      this.$v[field].$model = newVal;
      this.onBlur(); //tviv very much blures
    },
    handleAddBcc() {
      this.showBcc = true;
    },
    removeTag(field, email) {
      const existing = this.$v[field].$model
        .split(',')
        .map(item => item.trim())
        .filter(item => item && item !== email);
      this.$v[field].$model = existing.join(', ');
      this.onBlur();
    },
    hideCc() {
      this.showCc = false;
      this.ccEmailsVal = '';
      this.onBlur();
    },
    hideBcc() {
      this.showBcc = false;
      this.bccEmailsVal = '';
      this.onBlur();
    },
    // d99d
    handleSetFwd() {
      this.showFwd = true;
    },
    handleSetFrom() {
      this.showFrom = true;
    },
    // .
    onBlur() {
      this.$v.$touch();
      this.$emit('update:bccEmails', this.bccEmailsVal);
      this.$emit('update:fwdEmails', this.fwdEmailsVal);
      this.$emit('update:ccEmails', this.ccEmailsVal);
      this.$emit('update:toEmails', this.toEmailsVal);
      this.$emit('update:fromEmail', this.fromEmailVal);
    },
  },
};
</script>
<style lang="scss" scoped>
.email-head__row {
  @apply flex items-center gap-2
    border-b border-solid border-slate-75 dark:border-slate-700;
}

.email-head__fields {
  @apply flex-1 min-w-0;
}

.email-head__toggles {
  @apply flex items-center gap-2 shrink-0 py-2 px-4;
}

.email-head__row .input-group {
  @apply border-b-0;
}

.email-head__remove {
  @apply shrink-0 mx-2 w-5 h-5 flex items-center justify-center rounded
    text-base leading-none cursor-pointer
    text-gray-400 hover:text-gray-700 hover:bg-gray-100
    dark:text-slate-400 dark:hover:text-slate-100 dark:hover:bg-slate-700;
}

.email-head__toggle {
  @apply px-3 py-1 rounded-lg cursor-pointer whitespace-nowrap
    text-sm leading-5 text-gray-700 dark:text-slate-200
    bg-white dark:bg-slate-800
    border border-solid border-gray-300 dark:border-slate-600
    hover:bg-gray-50 dark:hover:bg-slate-700;
}

.input-group-wrap .message {
  @apply text-sm text-red-500 dark:text-red-500;
}
.input-group {
  @apply border-b border-solid border-slate-75 dark:border-slate-700 mb-0;

  .input-group-label {
    @apply border-transparent bg-transparent text-xs font-semibold px-4;
  }
  .input-group-field::v-deep input {
    @apply mb-0 border-transparent h-[40px];
  }
}

.input-group.error {
  @apply border-b-red-500 dark:border-b-red-500;
  .input-group-label {
    @apply text-red-500 dark:text-red-500;
  }
}
</style>
